import {
  RangeDirection,
  TimeRange,
  TimeRangeResult,
  TimeScale,
  Timestamp,
} from 'modules/Monitoring/types'

import { calculateInitialTimeRangePages } from './calculateInitialTimeRangePages'
import { calculatePreviousTimeRange } from './calculatePreviousTimeRange'

export const calculateNextTimeRange = ({
  direction,
  currentTimeRangeIndex,
  ranges,
  timeScale,
  supportsFuture = false,
}: {
  direction: RangeDirection
  currentTimeRangeIndex: number
  ranges: TimeRange[]
  timeScale: TimeScale
  supportsFuture?: boolean
}): TimeRangeResult<Timestamp, true> | null => {
  if (direction === RangeDirection.Next && ranges[currentTimeRangeIndex + 1]) {
    if (ranges[currentTimeRangeIndex + 2]) {
      return {
        ranges: undefined,
        rangeIndex: currentTimeRangeIndex + 1,
      }
    }

    return {
      rangeIndex: supportsFuture ? 1 : 0,
      ranges: calculateInitialTimeRangePages({ timeScale, supportsFuture }),
    }
  }

  if (direction === RangeDirection.Previous) {
    if (ranges[currentTimeRangeIndex - 1]) {
      return {
        ranges: undefined,
        rangeIndex: currentTimeRangeIndex - 1,
      }
    }

    const newPages = [...ranges]

    newPages.unshift(
      calculatePreviousTimeRange({
        range: ranges[currentTimeRangeIndex],
        scale: timeScale,
      }),
    )

    return {
      rangeIndex: undefined,
      ranges: newPages,
    }
  }

  return null
}
